const style = _theme => ({
  video: {
    display: 'none',
  }
});

export default style;
